
<div id="app">
  <b-loading :active="isLoading"></b-loading>
  <p class="no-mobile-app-info">
    Niestety aplikacja nie jest aktualnie przygotowana do pracy na urządzeniach mobilnych.
    <br/>Prosimy o kontakt z autorem w celu dopasowania aplikacji pod swoje preferencje.
  </p>
  <nav-bar
      v-if="isLogged"
      @new-order-click="showNewOrderModal"
      @new-user-click="showNewUserModal"
      @new-permament-point-click="showNewPermanentPointModal"
      @logout-click="logout"
  ></nav-bar>

  <router-view
      class="RouterView"
      @map-order-click="showViewOrderModal"
      @order-click="showViewOrderModal"
      @route-click="showViewRouteModal"
      @user-click="showViewUserModal"
      @permanent-point-click="showViewPermanentPointModal"
  />

  <b-modal
      :active="isNewUserModalActive"
      has-modal-card
      @close="hideNewUserModal"
      class="NewUserModal"
  >
    <new-user-modal/>
  </b-modal>
  <b-modal
      :active="isViewUserModalActive"
      has-modal-card
      @close="hideViewUserModal"
      @order-click="showViewOrderModal"
      class="ViewUserModal"
  >
    <view-user-modal
        :isGmailActivated="isGmailActivated"
        :isGmailDeactivated="isGmailDeactivated"
    />
  </b-modal>
  <b-modal
      :width="1200"
      :active="isViewOrderModalActive"
      has-modal-card
      @close="hideViewOrderModal"
      @route-click="showViewRouteModal"
      class="ViewOrderModal"
  >
    <view-order-modal/>
  </b-modal>
  <b-modal
      :active="isNewOrderModalActive"
      has-modal-card
      @close="hideNewOrderModal"
      class="NewOrderModal"
  >
    <new-order-modal/>
  </b-modal>
  <b-modal
      :active="isViewRouteModalActive"
      has-modal-card
      @close="hideViewRouteModal"
      @order-click="showViewOrderModal"
      class="ViewRouteModal"
      :width="1200"
  >
    <view-route-modal/>
  </b-modal>
  <b-modal
      :active="isPermanentPointModalActive"
      has-modal-card
      @close="hideNewPermanentPointModal"
      class="NewPermanentPointModal"
  >
    <permanent-point-modal/>
  </b-modal>
</div>
